export default __webpack_public_path__ + "static/media/panel-bg-dark.2c1c24c6.png";